import React, { Component } from 'react';
import differenceWith from 'lodash/differenceWith';
import intersectWith from 'lodash/intersectionWith';
import { v4 as uuidv4 } from 'uuid';

class ActionStepsList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      items: [],
    };
    this.order = {};

    this.addItem = this.addItem.bind(this);
    this.removeItem = this.removeItem.bind(this);
    this.updateItem = this.updateItem.bind(this);
    this.transform = this.transform.bind(this);
    this.onActionStepsUlRef = this.onActionStepsUlRef.bind(this);
  }

  UNSAFE_componentWillMount() {
    const p = this.props;
    p.items.forEach(this.addItem);
    this.transform(p);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const p = this.props;
    const np = nextProps;

    if (np.items !== p.items) {
      const added = differenceWith(np.items, p.items, (arrVal, othVal) => arrVal.Id === othVal.Id);
      const removed = differenceWith(
        p.items,
        np.items,
        (arrVal, othVal) => arrVal.Id === othVal.Id,
      );
      const updated = intersectWith(np.items, p.items, (arrVal, othVal) => arrVal.Id === othVal.Id);
      updated.forEach(this.updateItem);
      removed.forEach(this.removeItem);
      added.forEach(this.addItem);
    }
    this.transform(np);
  }

  onActionStepsUlRef(actionStepsUl) {
    const p = this.props;
    if (p.onActionStepsUlRef) {
      if (!this.uuid) {
        this.uuid = uuidv4();
      }
      p.onActionStepsUlRef(actionStepsUl, this.uuid);
    }
  }

  addItem(item) {
    Object.keys(this.order).forEach(key => {
      this.order[key].index += 1;
    });
    this.order[item.Id] = {
      data: item,
      index: 0,
    };
  }

  updateItem(item) {
    this.order[item.Id].data = item;
  }

  removeItem(item) {
    const { index } = this.order[item.Id];
    delete this.order[item.Id];
    Object.keys(this.order).forEach(key => {
      if (this.order[key].index > index) {
        this.order[key].index -= 1;
      }
    });
  }

  transform(p) {
    const items = p.items.map(() => 0);
    Object.keys(this.order).forEach(key => {
      items[this.order[key].index] = this.order[key].data;
    });
    this.setState({
      items,
    });
  }

  render() {
    const p = this.props;
    const s = this.state;
    return (
      <ul className="mobile-action-steps-ul">
        {s.items.length <= 0 && !p.isAdding && (
          <li className="mobile-action-steps-li-empty">{p.emptyStateText}</li>
        )}
        {s.items.map(item => (
          <li
            key={item.Id}
            className="mobile-action-steps-li"
            style={{
              display: item.IsHidden ? 'none' : 'block',
            }}
          >
            <div
              className={
                item.IsComplete ? 'mobile-action-steps-text is-done' : 'mobile-action-steps-text'
              }
            >
              {item.Text || '\u00a0'}
            </div>
            <div className="mobile-action-steps-buttons">
              {item.IsTask && (
                <i
                  tabIndex="0"
                  role="button"
                  onClick={p.onChangeStatus({
                    Completion: !item.IsComplete,
                    Text: item.Text,
                    ActionStepKey: item.ActionStepKey,
                  })}
                  onKeyDown={() => {}}
                  className={`far callout-init${
                    item.IsComplete ? ' btn-done fa-check-circle' : ' btn-not-done fa-circle'
                  }`}
                />
              )}
            </div>
          </li>
        ))}
      </ul>
    );
  }
}

export default ActionStepsList;
